import type { PropsWithChildren } from 'react'
import { ChakraProvider, Theme } from 'tcm-chakra-ui'
import { system } from '../../theme/system'

/**
 * v3 ChakraProvider + Theme subtree: isolates TCM tokens (`--tcm-*`) and applies
 * `.chakra-theme` so semantic tokens / recipes resolve when embedded under RM v2.
 */
export function AppProvider({ children }: PropsWithChildren) {
  return (
    <ChakraProvider value={system}>
      <Theme
        appearance="light"
        className="tcm-chakra-root chakra-theme"
        minH="100%"
        style={{ colorScheme: 'light' }}
      >
        {children}
      </Theme>
    </ChakraProvider>
  )
}
